import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { InstanceStatusSync } from '../../utils/instanceStatusSync';

/**
 * Componente responsável por inicializar a sincronização automática
 * de status das instâncias WhatsApp quando o usuário está autenticado
 */
const InstanceSyncInitializer: React.FC = () => {
  const { authState } = useAuth();
  const { user, loading } = authState;

  useEffect(() => {
    // Só iniciar sincronização se o usuário estiver autenticado
    if (user && !loading) {
      // Iniciar sincronização automática a cada 3 minutos
      InstanceStatusSync.startAutoSync(3);
      
      // Cleanup: parar sincronização quando o componente for desmontado
      return () => {
        InstanceStatusSync.stopAutoSync();
      };
    } else if (!user && !loading) {
      // Se o usuário não estiver autenticado, parar sincronização
      InstanceStatusSync.stopAutoSync();
    }
  }, [user, loading]);

  // Este componente não renderiza nada visível
  return null;
};

export default InstanceSyncInitializer;